import m from "../../geodata/es2015/fijiWestHigh";
window.am4geodata_fijiWestHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/fijiWestHigh.js
// module id = null
// module chunks = 